export default __webpack_public_path__ + "static/media/piraten-vector.708024a5.svg";